import { JSX } from 'react';

export const popUpOutlet = {
	item: ({ x = -2.375, y = -2.6875, opacity = 1 }: {x?: number; y?: number; opacity?: number;}): JSX.Element => {
		return <g fill="none" stroke="black" strokeWidth="0.125" transform={`translate(${x}, ${y})`} opacity={opacity}>
			<rect x="0" y="0" height="5.375" width="4.75" fill="none"/>
			<line x1="0.9625" y1="0.5" x2="0.9625" y2="4.0"/>
			<line x1="1.6625" y1="0.5" x2="1.6625" y2="4.0"/>
			<line x1="2.9625" y1="0.5" x2="2.9625" y2="4.0"/>
			<line x1="3.6625" y1="0.5" x2="3.6625" y2="4.0"/>
			<circle cx="1.325" cy="1.75" r="0.85" fill="none"/>
			<circle cx="3.35" cy="1.75" r="0.85" fill="none"/>
		</g>;
	},
	cutout: ({ x = -2.375, y = -2.6875, opacity = 1 }: {x?: number; y?: number; opacity?: number;}): JSX.Element => {
		return <g fill="none" stroke="black" strokeWidth="0.125" transform={`translate(${x}, ${y})`} opacity={opacity}>
			<rect x="0" y="0" height="5.375" width="4.75" fill="none"/>
			<line x1="0.9625" y1="0.5" x2="0.9625" y2="4.0"/>
			<line x1="1.6625" y1="0.5" x2="1.6625" y2="4.0"/>
			<line x1="2.9625" y1="0.5" x2="2.9625" y2="4.0"/>
			<line x1="3.6625" y1="0.5" x2="3.6625" y2="4.0"/>
			<circle cx="1.325" cy="1.75" r="0.85" fill="none"/>
			<circle cx="3.35" cy="1.75" r="0.85" fill="none"/>
		</g>;
	}
};
